import { Box, Grid } from "@mui/material"
import AppDialog from "../../../components/Common/AppDialog"
import Label from "../../../components/Common/Label"
import Helpers from "../../../helpers/helpers"
import ImportantNotice from "../../../components/Common/ImportantNotice"
import { useState } from "react"

export default function RenewAdvert({ open, close, handleSubmit, advertDetails, windowWidth, isBulkAction = false, selectedItems = [] }) {
    const [showAll, setShowAll] = useState(false);
    const itemsToShow = isBulkAction ? showAll ? selectedItems : selectedItems.slice(0, 2) : [];
    return (
        <AppDialog
            title={'Renew Advert'}
            open={open}
            close={close}
            positiveTitle={'Renew'}
            positivePress={() => handleSubmit()}
            cancelButton={true}
            width={'60%'}
            isMobile={windowWidth <= 768}
        >
            {
                isBulkAction ?
                    <>
                        <div>Are you sure you want to renew {selectedItems.length} selected advert(s) for 30 days?</div>
                        <ol style={{ paddingInline: 20, paddingBlock: 10 }}>
                            {itemsToShow?.map((item, idx) => (
                                <li key={idx} className="mb-2 ">
                                    <div className="d-flex align-items-center">
                                        {item?.make?.name || '-'} {item?.model?.model_name || ''}
                                        <Label.GeneralStatusLabel label={item?.status || '-'} list={Helpers.advertStatus} marginLeft={"10px"} />
                                    </div>
                                </li>
                            ))}
                            {selectedItems.length > 2 && (
                                <div
                                    onClick={() => setShowAll(!showAll)}
                                    className="clickable underline"
                                    style={{ marginTop: '10px' }}
                                >
                                    {showAll ? 'Show less' : 'Show more'}
                                </div>
                            )}
                        </ol>
                    </>
                    :
                    <>
                        <Grid container md={12} sm={12} xs={12}>
                            <Grid item lg={2} md={2} sm={12} xs={12} className="">
                                <img src={advertDetails?.images?.find((item) => item?.type === 'thumbnail')?.base64 || Helpers.noImage} style={{ width: '100%', height: 80, objectFit: 'contain' }} />
                            </Grid>
                            <Grid item lg={10} md={10} sm={12} xs={12} px={1} className="d-flex align-items-center">
                                <div>
                                    <div className="text-bold font-size-18">{advertDetails?.info?.title || '-'}</div>
                                    <div className="d-flex align-items-center">
                                        <Label.GeneralStatusLabel label={'published'} list={Helpers.advertStatus} marginLeft={"0px"} />
                                        <div className="d-flex mx-2">
                                            <span className="subheader-2" style={{ marginRight: 5 }}>Listing ID: </span>
                                            {advertDetails?.display_id || '-'}
                                        </div>
                                        <div className="d-flex mx-2">
                                            <span className="subheader-2" style={{ marginRight: 5 }}>Listed On: </span>
                                            {advertDetails?.created_at || '-'}
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                        <Box my={2}>
                            Your advert is about to expire. Renewing this advert will extend its visibility on the marketplace and keep it discoverable by potential buyers.
                        </Box>
                    </>
            }

            <Grid container spacing={2} mb={2}>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="subheader-2">
                        Current Expiry Date:
                    </div>
                </Grid>
                <Grid item className="text-bold" lg={6} md={6} sm={12} xs={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'start' } }}>
                    {advertDetails?.advert_plan?.current_expiry_date || '-'}
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="subheader-2">
                        New Expiry Date (after renewal):
                    </div>
                </Grid>
                <Grid item className="text-bold" lg={6} md={6} sm={12} xs={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'start' } }}>
                    {advertDetails?.advert_plan?.renew_expiry_date || '-'}
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="subheader-2">
                        Duration:
                    </div>
                </Grid>
                <Grid item className="text-bold" lg={6} md={6} sm={12} xs={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'start' } }}>
                    +{advertDetails?.advert_plan?.duration_in_days || 0}
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="subheader-2">
                        Credits Required:
                    </div>
                </Grid>
                <Grid item className="text-bold" lg={6} md={6} sm={12} xs={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'start' }, color: '#34C759' }}>
                    {advertDetails?.advert_plan?.credit_required || 0} Credits
                </Grid>
            </Grid>
            <div className="my-2">
                <ImportantNotice
                    iconName={'solar:lightbulb-linear'}
                    iconColor={'#1D1B1B'}
                    backgroundColor={'#F0F0F0'}
                    color={'#1D1B1B'}
                    message={'Renewal will immediately deduct credits from your available balance. If your credit balance is insufficient, you will be prompted to top up before completing the renewal.'}
                />
            </div>
        </AppDialog>
    )
}